<div id="{{'chart_plannedloadincrease_' + TeamId}}">

</div>
<div id="{{'chart_plannedloadincrease_ma_' + TeamId}}">

</div>


